import React, { useState, useEffect, Fragment } from "react";
import { Col, Row, Container } from "react-bootstrap";
// import { GetAllLogs } from "./getAllDetails";
// import useCollapse from "react-collapsed";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@mui/styles";
import {
  Button,
  CardActionArea,
  CardActions,
  MenuItem,
  Select,
} from "@mui/material";
import ArrowCircleRightRoundedIcon from "@mui/icons-material/ArrowCircleRightRounded";
import IconButton from "@mui/material/IconButton";
import { CardContent, Divider, CardHeader, Box } from "@mui/material";
// import axios from 'axios';
import MDBox from "components/MDBox";
import { GetAllVideos, getTodaysCheckOuts } from "./Url";

import { GetAllBuildings } from "layouts/downloadData/Urls";
import { getAllBuildings } from "redux/actions/RatActions";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import { todaysCheckOutGuest } from "redux/actions/GuestActions";
import { useNavigate } from "react-router-dom";
import axios from "../../Uri";
import MDTypography from "components/MDTypography";
const TodayCheckOut = () => {
  const [data, setData] = useState([]);
  const [selected, setSelected] = React.useState("");
  const [building, setBuilding] = React.useState([]);
  const [buildingId, setBuildingId] = React.useState(null);
  const navigate = useNavigate();

  // ✅ Get userType and buildingId from sessionStorage
  const userData = JSON.parse(sessionStorage.getItem("userdata"));
  const typeOfUser = userData?.data?.userType || "";
  const managerBuildingId = userData?.data?.buildingId || null;

  useEffect(() => {
    GetAllBuildings()
      .then((res) => {
        let allBuildings = res.data;

        // ✅ Filter if manager
        if (typeOfUser.toLowerCase() === "manager" && managerBuildingId) {
          allBuildings = allBuildings.filter(
            (b) => b.buildingId === managerBuildingId
          );

          // Auto-select manager's building
          if (allBuildings.length > 0) {
            setSelected(allBuildings[0].buildingName);
            setBuildingId(allBuildings[0].buildingId);
          }
        }

        setBuilding(allBuildings);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong🤦‍♂️");
      });
  }, [typeOfUser, managerBuildingId]);

  useEffect(() => {
    if (buildingId !== null) {
      getTodaysCheckOuts(buildingId)
        .then((res) => {
          console.log(res.data);
          setData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [buildingId]);

  const useStyles = makeStyles({
    root: { height: 35 },
    size: { width: 40, height: 30 },
  });
  const classes = useStyles();

  return (
    <Grid container style={{ marginLeft: 12, marginBottom: 20 }}>
      <Grid item xs={6}>
        {/* <label value="Select Building: ">
          <strong>Select Building:</strong>
        </label> */}

        {/* ✅ Only show dropdown for Admin */}
        {typeOfUser.toLowerCase() === "admin" && (
          <Select
            sx={{ minHeight: 44 }}
            style={{
              width: "40%",
              height: "10%",
              marginTop: "20px",
              marginLeft: "12px",
            }}
            value={selected}
            name="building"
            IconComponent={() => <ArrowDropDownIcon className={classes.size} />}
          >
            {building.map((post) => (
              <MenuItem
                key={post.buildingId}
                value={post.buildingName}
                onClick={() => {
                  setSelected(post.buildingName);
                  setBuildingId(post.buildingId);
                }}
              >
                {post.buildingName}
              </MenuItem>
            ))}
          </Select>
        )}

        <Button
          variant="contained"
          size="lg"
          style={{
            marginBottom: 12,
            marginTop: 20,
            marginLeft: 20,
            color: "white",
          }}
          onClick={() => {
            navigate("/exceededGuest");
          }}
        >
          View Exceeded Guest
        </Button>
      </Grid>

      <Grid container item lg={12} style={{ marginBottom: 20, marginRight: 20 }}>
        {data.map((post) => (
          <Card
            key={post.guestId}
            xs={12}
            md={6}
            lg={3}
            sx={{
              m: "20px",
              background: "linear-gradient(90deg, #f2e6ff 10%, #cceeff 50%)",
            }}
            style={{
              width: 300,
              border: "0",
              marginRight: "6px",
              marginBottom: "6px",
            }}
          >
            <CardHeader
              avatar={
                <Avatar
                  variant="square"
                  style={{
                    width: "70px",
                    height: "80px",
                    margingLeft: "130px",
                    color: "orange",
                  }}
                  alt={post.guestName}
                  src={post.imageUrl}
                />
              }
              title={
                <MDTypography
                  level="h2"
                  fontSize="md"
                  textColor="red"
                  mb={1}
                  sx={{
                    color: "ff66ff",
                    textShadow: "1px 1px #fff, 2px 2px #fff, 3px 3px #aaa",
                  }}
                >
                  <em>
                    <strong style={{ color: "purple" }}>{post.guestName}</strong>
                  </em>
                </MDTypography>
              }
            />

            <CardContent>
              <MDTypography level="h2" fontSize="sm" textColor="#000000" mb={1}>
                <strong style={{ color: "#000000" }}>
                  <em>BedId:</em>
                </strong>
                <em>
                  <strong style={{ color: "#333399", fontSize: "19px" }}>
                    {post.bedId}
                  </strong>
                </em>
              </MDTypography>

              <MDTypography level="h2" fontSize="sm" textColor="#000000" mb={1}>
                <strong style={{ color: "#000000" }}>
                  <em>PlannedDate:</em>
                </strong>
                <em>
                  <strong style={{ color: "red", fontSize: "19px" }}>
                    {post.plannedCheckOutDate}
                  </strong>
                </em>
              </MDTypography>

              <MDTypography level="h2" fontSize="sm" textColor="#000000" mb={1}>
                <strong style={{ color: "#000000" }}>
                  <em>Building:</em>
                </strong>
                <em>
                  <strong style={{ color: "#333399", fontSize: "19px" }}>
                    {post.buildingName}
                  </strong>
                </em>
              </MDTypography>
            </CardContent>
          </Card>
        ))}
      </Grid>
    </Grid>
  );
};

export default TodayCheckOut;

